import React from "react";

export const SectionHeader: React.FC<{
  title: string;
  description: string;
}> = ({ title, description }) => (
  <div className="flex gap-4">
    <div className="w-px self-stretch rounded-[1px] bg-[#E0E0E0]" />
    <div className="flex flex-col gap-1">
      <span className="text-dark font-secondary font-medium">{title}</span>
      <span className="text-dark-600 font-secondary text-[13px]">
        {description}
      </span>
    </div>
  </div>
);
